import { isDate } from '@utils/guards';
import { formatDate } from '@vueuse/core';

export interface FormatMonthDateComposable {
  formatMonthDate<T extends Date | Date[]>(date: T, format?: string): T extends Date ? string : string[];
  formatToString(val: Date, format: string): string;
}

export default function useFormatMonthDate(): FormatMonthDateComposable {
  function formatToString(val: Date, format: string): string {
    return isDate(val) ? formatDate(val, format) : '';
  }

  function formatMonthDate<T extends Date | Date[]>(date: T, format = 'MM.YYYY'): T extends Date ? string : string[] {
    if (Array.isArray(date)) {
      return date.map((val) => formatToString(val, format)) as any;
    }
    return formatToString(date, format) as any;
  }

  return {
    formatMonthDate,
    formatToString,
  };
}
